// extracted by mini-css-extract-plugin
export default {"modalEmployerSkills":"ModalEmployerSkills_modalEmployerSkills__KAFgF","checkboxes":"ModalEmployerSkills_checkboxes__aVKsE"};